import { render, staticRenderFns } from "./JoinHeader.vue?vue&type=template&id=d5a33b24&scoped=true&"
import script from "./JoinHeader.vue?vue&type=script&lang=js&"
export * from "./JoinHeader.vue?vue&type=script&lang=js&"
import style0 from "./JoinHeader.vue?vue&type=style&index=0&id=d5a33b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a33b24",
  null
  
)

export default component.exports